import { DateTime } from 'luxon';

export const getUploadTicketParams = (id, requestorType, attribute, fileName) => ({
  upload_ticket: {
    'requestor-id': id,
    'requestor-type': requestorType,
    'requestor-attribute': attribute,
    filename: fileName,
  },
});

export const formatKeys = attrs =>
  Object.keys(attrs).reduce(
    (acc, key) => ({
      ...acc,
      [key.replace('-', '_')]: attrs[key],
    }),
    {}
  );

export const bodyWithLockVersion = (entity = {}, values = {}) => ({
  ...values,
  'lock-version': entity?.['lock-version'],
});

export const getJSDateFromISO = (date = '') => (date ? DateTime.fromISO(date).toJSDate() : null);

export const checkIfPublicRoute = (pathname) => {
  return (
    pathname.includes('/order-type') || pathname.includes('/snooze') || pathname.includes('/play') || pathname.includes('/tell_a_story') || pathname.includes('/get-started') || pathname.includes('/redeem-gift-certificate') || pathname.includes('/password') || pathname.includes('watch_me_grow') || pathname.includes('founder-welcome') || pathname.includes('paywall') || pathname.includes('/family_tree/') || pathname.includes('/tft/') || pathname.includes('/shopify-onboarding')
  );
}

export function getPrefixedEventName(event, isMobile) {
  const route = window.location.pathname; // Get current route path
  const eventName = event ? '_' + event : '';
  // Check if the route contains '/mobile' to append '_mobile'


  // Check for "/redeem-gift-certificate" in the route
  if (route.includes('/watch-me-grow/get-started')) {
    return `b1y_buy_wmg_from_marcom${eventName}_v6`;
  }
  if (route.includes('/watch-me-grow')) {
    return `b1y_buy_wmg_internal${eventName}_v6`;
  }
  // Check for "/redeem-gift-certificate" in the route
  if (route.includes('/redeem-gift-certificate')) {
    return `b1y_redeem${eventName}${isMobile ? '_mobile' : ''}_v6`;
  }

  // Check for "/onboarding" in the route
  if (route.includes('/get-started') || route === '/') {
    return `b1y_self_serve${eventName}${isMobile ? '_mobile' : ''}_v6`;
  }

  // Check for "/gift" in the route
  if (route.includes('/gift')) {
    return `b1y_buy_gc${eventName}${isMobile ? '_mobile' : ''}_v6`;
  }

  // Default to just eventName if no matching route is found
  return `${eventName}${isMobile ? '_mobile' : ''}`;
}

export const getAllPackages = (data, noFreePlan = false) => {
  if (!data?.data) return null;

  const result = data?.data?.map(({
    attributes,
    relationships
  }) => {
    const { description, group, 'sub-title': subTitle, title, id, footer,
      'price-headline': priceHeadline
    } = attributes

    const subscriptionPricing = data.included.find(
      (item) =>
        item.type === 'pricing-plans' &&
        item.id === relationships?.['subscription-pricing-plan']?.data?.id
    );
    const productPricing = data.included.find(
      (item) =>
        item.type === 'pricing-plans' &&
        item.id === relationships?.['subscription-pricing-plan']?.data?.id
    );

    return {
      subscriptionPricing,
      id, description, group, subTitle, title,
      price: (productPricing || subscriptionPricing)?.attributes?.['price-in-dollars'],
      relationships,
      priceHeadline,
      footer
    }
  })

  return {
    ...(
      noFreePlan
        ? {}
        : { freePlan: result.find(({ price }) => price === 0) }
    ),
    paidPlans: result.filter(({ price, relationships }) => price !== 0 && !!relationships?.['product-pricing-plan']?.data),
    wmgPlan: result.find(({ price, relationships }) => price !== 0 && !relationships?.['product-pricing-plan']?.data)
  };
}